module.exports = __webpack_public_path__ + "static/media/c-igm-igg.f2ab060d.png";